/*
 * @description:
 * @param:
 * @return:
 */

export const changLang = [
  {
    changePassword: 'Change Password',
    password: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    submit: 'Submit',
    reset: 'Reset',
    enterPwd: 'Please enter password',
    enterNewPwd: 'Please enter new password',
    enterNewPwdAgain: 'Please enter your new password again',
    noMath: 'The two passwords entered do not match!'
  },
  {
    changePassword: '修改密码',
    password: '密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    submit: '提交',
    reset: '重置',
    enterPwd: '请输入密码',
    enterNewPwd: '请输入新密码',
    enterNewPwdAgain: '请再次输入新密码',
    noMath: '两次输入密码不一致'
  },
  {
    changePassword: 'تغيير كلمة المرور',
    password: 'كلمة المرور الأصلي',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    enterPwd: 'الرجاء إدخال كلمة المرور',
    enterNewPwd: 'الرجاء إدخال كلمة المرور الجديدة',
    enterNewPwdAgain: 'الرجاء إدخال كلمة المرور الجديدة مرة أخرى',
    noMath: 'كلمات المرور التي أدخلتها مرتين غير متطابقة!'
  },
  {
    changePassword: 'Cambiar Contraseña',
    password: 'Contraseña anterior',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar ',
    submit: 'Subir',
    reset: 'Reiniciar',
    enterPwd: 'Por favor, introduzca la contraseña',
    enterNewPwd: 'Poner nueva Contraseña',
    enterNewPwdAgain: 'Poner nueva Contraseña otra vez',
    noMath: '¡Las dos contraseñas puestas no coinciden!'
  }
]

export const homeLang = [
  {
    changePassword: 'Change Password',
    logout: 'Log out',
    nextTommorrow: 'Daily Countdown',
    nextWeek: 'Weekly Countdown',
    day: 'd',
    hour: 'h',
    minute: 'm',
    second: 's',
    copy: 'Copy',
    baseInfo: 'Basic Information',
    agency: 'Agency Details',
    hostess: 'Host Details',
    report: 'Reports',
    dayReoirt: 'Daily Report',
    weekReport: 'Weekly Report',
    settlement: 'Salary Report',
    block: 'Ban Records',
    agentID: 'Invitation Code'
  },
  {
    changePassword: '修改密码',
    logout: '退出',
    nextTommorrow: '距离明天',
    nextWeek: '距离下周',
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    copy: '复制',
    agentID: '邀请码',
    baseInfo: '基础信息',
    agency: '代理',
    hostess: '主播',
    report: '报表',
    dayReoirt: '日报表',
    weekReport: '周报表',
    settlement: '结算报表',
    block: '封禁记录'
  },
  {
    changePassword: 'تغيير كلمة المرور',
    logout: 'خروج من الحساب',
    nextTommorrow: 'العد التنازلي اليومي',
    nextWeek: 'العد التنازلي الأسبوعي',
    day: 'أيام',
    hour: 'ساعة',
    minute: 'دقيقة',
    second: 'ثانية',
    copy: 'النسخ',
    baseInfo: 'المعلومات الأساسية',
    agency: 'تفاصيل الوكالة',
    hostess: 'تفاصيل المضيفة',
    report: 'التقارير',
    dayReoirt: 'التقرير اليومي',
    weekReport: 'التقرير الأسبوعي',
    settlement: 'تقرير التسوية',
    block: 'سجلات الحظر',
    agentID: 'كود الدعوة'
  },
  {
    changePassword: 'Cambiar Contraseña',
    logout: 'Cerrar Sesión',
    nextTommorrow: 'Hasta Mañana',
    nextWeek: 'Hasta Próxima Semana',
    day: 'd',
    hour: 'h',
    minute: 'm',
    second: 's',
    copy: 'Copiar',
    baseInfo: 'Información Básica',
    agency: 'Detalles de Agencia',
    hostess: 'Detalles de Anfitrionas',
    report: 'Informe de Ingresos',
    dayReoirt: 'Informe Diario',
    weekReport: 'Informe Semanal',
    settlement: 'Informe de Nómina',
    block: 'Registro de Bloqueos',
    agentID: 'Código de Invitación'
  }
]

export const loginLang = [
  {
    login: 'Login',
    reset: 'Reset',
    noAccount: 'Incorrect account',
    noPwd: 'Incorrect password'
  },
  {
    login: '登录',
    reset: '重置',
    noAccount: '请输入登录名称',
    noPwd: '请输入登录密码'
  }
]

export const overviewLang = [
  {
    overview: 'Overview',
    hostId: 'Hostess ID',
    download: 'Download',
    agency: 'Agency',
    search: 'Search'
  },

  {
    overview: '总览',
    hostId: '主播ID',
    download: '下载',
    agency: '代理选项',
    search: '查看'
  }
]

export const databaseAgent = [
  {
    agency: 'Agency Details',
    agencyId: 'Agent ID',
    agencyName: 'Agency Name',
    search: 'Search',
    inviteCode: 'Invitation Code',
    registerHostess: 'Number of Hosts Invited',
    reviewSuccessCount: 'Number of Hosts Approved',
    totalUSDIncome: 'Total Revenue',
    selectstartDate: 'Select Start Date',
    selectendDate: 'Select End Date'
  },
  {
    agency: '代理',
    agencyId: '代理ID',
    agencyName: '代理名',
    search: '查询',
    inviteCode: '邀请码',
    registerHostess: '邀请主播数量',
    reviewSuccessCount: '过审主播数量',
    totalUSDIncome: '总收入USD',
    selectstartDate: '选择开始日期',
    selectendDate: '选择结束日期'
  },
  {
    agency: 'تفاصيل الوكالة',
    agencyId: 'معرف الوكيل',
    agencyName: 'اسم الوكالة',
    search: 'بحث',
    inviteCode: 'كود الدعوة',
    registerHostess: 'عدد المضيفات المدعوات',
    reviewSuccessCount: 'عدد المضيفات المعتمَدات',
    totalUSDIncome: 'إجمالي الدخل (بالدولار)',
    selectstartDate: 'اختر تاريخ البدء',
    selectendDate: 'اختر تاريخ الانتهاء'
  },
  {
    agency: 'Detalles de Agencia',
    agencyId: 'Código de Agencia',
    agencyName: 'Nombre de Agencia',
    search: 'Buscar',
    inviteCode: 'Código de Invitación',
    registerHostess: 'Anfitrionas Invitadas',
    reviewSuccessCount: 'Anfitrionas Verificadas',
    totalUSDIncome: 'Ganancia Total',
    selectstartDate: 'Selecciona fecha de inicio',
    selectendDate: 'Selecciona fecha de finalización'
  }
]

export const databaseHost = [
  {
    hostess: 'Host Details',
    inviteDate: 'Invitation Date',
    search: 'Search',
    hostessID2: 'ID',
    country: 'Host Country',
    name: 'Host Nickname',
    status: 'Account Verification Status',
    headIcon: 'Host Avatar',
    photo: 'Host Verification Photo',
    registerDate: 'Register Date',
    authPassTime: 'Verification Completed Date',
    lastLoginTime: 'Last Active Time',
    incomeBalance: 'Current Diamonds',
    totalUSDIncome: 'Historical Total Revenue',
    selectstartDate: 'Select Start Date',
    selectendDate: 'Select End Date',
    all: 'All',
    verification: 'In Verification',
    verComplete: 'Verification Completed',
    verFail: 'Verification Failed',
    unVerification: 'Unverified',
    hostAccountStatus: 'AccountStatus',
    available: 'Available',
    banned: 'Banned',
    deleted: 'Deleted',
    eliminated: 'Eliminated'

  },
  {
    hostess: '主播',
    inviteDate: '邀请日期',
    search: '查询',
    hostessID2: '主播ID',
    country: '主播国家',
    name: '主播名称',
    status: '主播认证状态',
    headIcon: '主播头像',
    photo: '主播认证头像',
    registerDate: '注册时间',
    authPassTime: '通过审核时间',
    lastLoginTime: '最后上线时间',
    incomeBalance: '实时账户余额钻石数',
    totalUSDIncome: '总收入USD',
    selectstartDate: '选择开始日期',
    selectendDate: '选择结束日期',
    all: '全部',
    verification: '认证中',
    verComplete: '认证通过',
    verFail: '认证失败',
    unVerification: '未认证',
    hostAccountStatus: '主播账号状态',
    available: '正常',
    banned: '封禁',
    deleted: '删除',
    eliminated: '淘汰'
  },
  {
    hostess: 'تفاصيل المضيفة',
    inviteDate: 'تاريخ الدعوة',
    search: 'بحث',
    hostessID2: 'ID',
    country: 'دولة المضيفة',
    name: 'اسم المضيفة',
    status: 'حالة التحقق من الحساب',
    headIcon: 'صورة الرمزية للمضيفة',
    photo: 'صورة التحقق للمضيفة',
    registerDate: 'تاريخ التسجيل',
    authPassTime: 'تاريخ اكتمال التحقق',
    lastLoginTime: 'آخر وقت نشاط',
    incomeBalance: 'الماس الحالي',
    totalUSDIncome: 'إجمالي الإيرادات التاريخية',
    selectstartDate: 'اختر تاريخ البدء',
    selectendDate: 'اختر تاريخ الانتهاء',
    all: 'الكل',
    verification: 'في التحقق',
    verComplete: 'اكتمل التحقق',
    verFail: 'فشل التحقق',
    unVerification: 'لم تبدأ عملية التحقق',
    hostAccountStatus: 'حالة حساب المضيفة',
    available: 'متاح',
    banned: 'محظور',
    deleted: 'محذوف',
    eliminated: 'تم الاستبعاد'
  },
  {
    hostess: 'Detalles de Anfitrionas',
    search: 'Buscar',
    inviteDate: 'Fecha de Invitación',
    hostessID2: 'ID',
    country: 'País',
    name: 'Apodo',
    status: 'Estado de verificación',
    headIcon: 'Foto de Perfil',
    photo: 'Foto de Verificación',
    registerDate: 'Fecha de Registro',
    authPassTime: 'Fecha de Verificación Completada',
    lastLoginTime: 'Última Hora Conectada',
    incomeBalance: 'Diamantes Actuales ',
    totalUSDIncome: 'Ganancia total',
    selectstartDate: 'Selecciona fecha de inicio',
    selectendDate: 'Selecciona fecha de finalización',
    all: 'Todo',
    verification: 'En Verificación',
    verComplete: 'Verificación Completada',
    verFail: 'Verificación Fallida',
    unVerification: 'Verificación no empezada',
    hostAccountStatus: 'Estado de cuenta ',
    available: 'Normal',
    banned: 'Bloqueada',
    deleted: 'Eliminada',
    eliminated: 'Eliminada'
  }
]

export const registered = [
  {
    hostessList: 'Hostess List',
    download: 'Download',
    downloadAll: 'Download All'
  },
  {
    hostessList: '主播注册报表',
    download: '下载',
    downloadAll: '下载全部'
  }
]

export const registeredLight = [
  {
    hostessperformance: 'Hostess performance',
    download: 'Download',
    search: 'Search',
    loading: 'loading'
  },
  {
    hostessperformance: '主播通话曝光表',
    download: '下载',
    search: '查询',
    loading: '拼命加载中'
  }
]

export const registeredEvaluation = [
  {
    agencyName: 'Agency Name',
    download: 'Download',
    search: 'Search',
    loading: 'loading',
    downloadAll: 'Download All'
  },
  {
    agencyName: '代理名称',
    download: '下载',
    search: '查询',
    loading: '拼命加载中',
    downloadAll: '下载全部'
  }
]

export const registeredBlocked = [
  {
    blockedlist: 'Blocked list',
    download: 'Download',
    search: 'Search',
    loading: 'loading',
    date: 'Date',
    userId: 'User ID',
    userName: 'User Name',
    blockdate: 'Block date',
    reason: 'Reason',
    coinsBalance: 'Coins balance',
    active: 'Active',
    unseal: 'Unseal',
    call1: 'First call violation image',
    call2: 'Second call violation image',
    call3: 'Third call violation picture'
  },
  {
    blockedlist: '封禁日志查询',
    download: '下载',
    search: '查询',
    loading: '拼命加载中',
    date: '日期',
    userId: '用户id',
    userName: '用户昵称',
    blockdate: '封禁时间',
    reason: '封禁原因',
    coinsBalance: '剩余金币数',
    active: '操作',
    unseal: '解封',
    call1: '第一次通话违规图片',
    call2: '第二次通话违规图片',
    call3: '第三次通话违规图片'
  }
]

export const childaccountadd = [
  {
    add: 'Add',
    loading: 'loading',
    agentID: 'Agent ID',
    password: 'Password',
    status: 'Status',
    active: 'Active',
    delete: 'Delete',
    addSubAccount: 'Add sub account'
  },
  {
    add: '添加',
    loading: '拼命加载中',
    agentID: '代理ID',
    password: '密码',
    status: '状态',
    active: '操作',
    delete: '删除',
    addSubAccount: '添加子账号'
  }
]

export const reportData = [
  {
    report: 'Daily Report',
    search: 'Search',
    date: 'Date of data',
    name: 'Nickname',
    rid: 'ID',
    appraiseScore: 'Grade',
    onlineDuration: 'Online Duration',
    liveDuration: 'Live Duration',
    answerRate: 'Response Rate',
    personalCallAvgTime: 'Average Duration of Private Calls',
    matchCallAvgTime: 'Average Duration of Match Calls',
    matchCallCount: 'Total Duration of Calls',
    personalCallIncomeUSD: 'Private Call Income',
    matchCallIncomeUSD: 'Matching Call Income',
    giftIncomeUSD: 'Gift Income',
    totalIncomeUSD: 'Daily Income',
    currDiamonds: 'Current Diamond Balance',
    selectData: 'Select Date',  
    export: 'Export',
    hostLevel: 'Grade',
    activeHost: 'Active Host',
    all: 'All',
    active: 'Active',
    inActive: 'Inactive',
    country: 'Country'
  },
  {
    report: '日报表',
    search: '查询',
    date: '数据日期',
    name: '主播昵称',
    rid: '主播ID',
    appraiseScore: '主播当日质量等级',
    onlineDuration: '主播当日有效在线时长',
    liveDuration: '主播当日Live时长',
    answerRate: '当日接听率',
    personalCallAvgTime: '主播当日私人通话平均时长',
    matchCallAvgTime: '主播当日匹配通话平均时长',
    matchCallCount: '主播当日总通话时长',
    personalCallIncomeUSD: '主播当日私人通话总收入USD',
    matchCallIncomeUSD: '主播当日匹配通话总收入USD',
    giftIncomeUSD: '当日礼物总收入USD',
    totalIncomeUSD: '当日总收入USD',
    currDiamonds: '主播当前余额',
    selectData: '请选择日期',
    export: '导出',
    hostLevel: '主播等级',
    activeHost: '活跃主播',
    all: '全部',
    active: '活跃',
    inActive: '非活跃',
    country: '国家:'
  },
  {
    report: 'التقرير اليومي',
    search: 'بحث',
    date: 'تاريخ البيانات',
    name: 'اسم المضيفة',
    rid: 'ID المضيفة',
    appraiseScore: 'مستوى',
    onlineDuration: 'مدة النشاط الفعال',
    liveDuration: 'مدة اللايف',
    answerRate: 'معدل الرد',
    personalCallAvgTime: 'متوسط مدة المكالمات الخاصة',
    matchCallAvgTime: 'متوسط مدة المكالمات المتطابقة',
    matchCallCount: 'إجمالي مدة المكالمات',
    personalCallIncomeUSD: 'دخل المكالمات الخاصة',
    matchCallIncomeUSD: 'دخل المكالمات المطابقة',
    giftIncomeUSD: 'دخل الهدايا',
    totalIncomeUSD: 'دخل اليومي (بالدولار)',
    currDiamonds: 'رصيد الماس الحالي',
    selectData: 'اختر التاريخ',
    export: 'تصدير',
    hostLevel: 'مستوى المضيفة',
    activeHost: 'المضيفة النشطة',
    all: 'الكل',
    active: 'نشطة',
    inActive: 'غير نشطة',
    country: 'الدولة'
  },
  {
    report: 'Informe Diario',
    search: 'Buscar',
    date: 'Fecha',
    name: 'Apodo',
    rid: 'ID',
    appraiseScore: 'Nivel',
    onlineDuration: 'Duración en línea',
    liveDuration: 'Duración en live',
    answerRate: 'Tasa de Respuesta',
    personalCallAvgTime: 'Duración promedia de llamadas privadas',
    matchCallAvgTime: 'Duración promedia de llamadas match',
    matchCallCount: 'Duración total de llamadas',
    personalCallIncomeUSD: 'Ingresos de llamadas privadas',
    matchCallIncomeUSD: 'Ingresos de llamadas Match',
    giftIncomeUSD: 'Ingresos de regalos',
    totalIncomeUSD: 'Ingreso total (USD)',
    currDiamonds: 'Diamantes actuales de billetera',
    selectData: 'Selecciona fecha',
    export: 'Descargar',
    hostLevel: 'Nivel',
    activeHost: 'Estado de trabajo',
    all: 'Todo',
    active: 'Conectada',
    inActive: 'No Conectada',
    country: 'País'
  }
]

export const reportWeek = [
  {
    report: 'Weekly Report',
    search: 'Search',
    selectData: 'Please select date',
    export: 'Export',
    date: 'Data Period',
    name: 'Nickname',
    rid: 'ID',
    hostLevel: 'Grade',
    activeHost: 'Active Host',
    country: 'Country',
    selectWeek: 'Select Week',
    appraiseScore: 'Host level Week',
    onlineDuration: 'Online Duration',
    liveDuration: 'Live Duration',
    answerRate: 'Response Rate',
    personalCallAvgTime: 'Average Private Call Duration',
    matchCallAvgTime: 'Average Match Call Duration',
    matchCallCount: 'Total Call Duration',
    personalCallIncomeUSD: 'Private Call Income',
    matchCallIncomeUSD: 'Matching Call Income',
    giftIncomeUSD: 'Gift Income',
    totalIncomeUSD: 'Weekly Income',
    currDiamonds: 'Current Diamond Balance',
    all: 'All',
    active: 'Active',
    inActive: 'Inactive'
  },
  {
    report: '周报表',
    search: '查询',
    selectData: '请选择日期',
    export: '导出',
    date: '数据周期',
    name: '主播昵称',
    rid: '主播ID',
    hostLevel: '主播等级',
    activeHost: '活跃主播',
    country: '国家:',
    selectWeek: '自然周选择',
    appraiseScore: '主播当周质量等级',
    onlineDuration: '主播当周有效在线时长',
    liveDuration: '主播当周Live时长',
    answerRate: '当周接听率',
    personalCallAvgTime: '主播当周私人通话平均时长',
    matchCallAvgTime: '主播当周匹配通话平均时长',
    matchCallCount: '主播当周总通话时长',
    personalCallIncomeUSD: '主播当周私人通话总收入USD',
    matchCallIncomeUSD: '主播当周匹配通话总收入USD',
    giftIncomeUSD: '当周礼物总收入USD',
    totalIncomeUSD: '当周总收入USD',
    currDiamonds: '主播当前余额',
    all: '全部',
    active: '活跃',
    inActive: '非活跃'
  },
  {
    report: 'التقرير الأسبوعي',
    search: 'بحث',
    selectData: 'الرجاء تحديد التاريخ',
    export: 'تصدير',
    date: 'تاريخ',
    name: 'اسم المضيفة',
    rid: 'ID',
    hostLevel: 'مستوى المضيفة',
    activeHost: 'المضيفة النشطة',
    country: 'الدولة:',
    selectWeek: 'اختر الأسبوع',
    appraiseScore: 'مستوى جودة المرساة للأسبوع',
    onlineDuration: 'مدة النشاط الفعال',
    liveDuration: 'مدة اللايف',
    answerRate: 'معدل الرد',
    personalCallAvgTime: 'متوسط مدة المكالمات الخاصة',
    matchCallAvgTime: 'متوسط مدة المكالمات المتطابقة',
    matchCallCount: 'إجمالي مدة المكالمات',
    personalCallIncomeUSD: 'دخل المكالمات الخاصة',
    matchCallIncomeUSD: 'دخل المكالمات المطابقة',
    giftIncomeUSD: 'دخل الهدايا',
    totalIncomeUSD: 'الدخل الأسبوعي (بالدولار)',
    currDiamonds: 'رصيد الماس الحالي',
    all: 'الكل',
    active: 'نشطة',
    inActive: 'غير نشطة'
  },
  {
    report: 'Informe Semanal',
    search: 'Buscar',
    selectData: 'Por favor selecciona la fecha',
    export: 'Descargar',
    date: 'Fecha',
    name: 'Apodo',
    rid: 'ID',
    hostLevel: 'Nivel',
    activeHost: 'Estado de trabajo',
    country: 'País',
    selectWeek: 'Seleccionar semana',
    appraiseScore: 'Nivel de calidad del anfitrión de la semana',
    onlineDuration: 'Duración en línea',
    liveDuration: 'Duración en live',
    answerRate: 'Tasa de Respuesta',
    personalCallAvgTime: 'Duración promedia de llamadas privadas',
    matchCallAvgTime: 'Duración promedia de llamadas match',
    matchCallCount: 'Duración total de llamadas',
    personalCallIncomeUSD: 'Ingresos de llamadas privadas',
    matchCallIncomeUSD: 'Ingresos de llamadas Match',
    giftIncomeUSD: 'Ingresos de regalos',
    totalIncomeUSD: 'Ingreso total',
    currDiamonds: 'Diamantes actuales de billetera',
    all: 'Todo',
    active: 'Conectada',
    inActive: 'No Conectada'
  }
]

export const settlement = [
  {
    settlement: 'Salary Report',
    search: 'Search',
    selectData: 'Select Date',
    date: 'Date of data',
    country: 'Country',
    name: 'Nickname',
    export: 'Export',
    rid: 'ID',
    lastWeekRangeBalance: 'Diamonds withdrawn last week',
    lastWeekRangeBalanceUSD: 'Amount of withdrawals last week',
    rangeBalance: 'Diamonds withdrawn this week',
    rangeBalanceUSD: 'Amount of withdrawals this week'
  },
  {
    settlement: '结算报表',
    search: '查询',
    selectData: '选择日期',
    date: '数据日期',
    country: '主播国家',
    name: '主播昵称',
    export: '导出',
    rid: '主播ID',
    lastWeekRangeBalance: '主播上周结算钻石数',
    lastWeekRangeBalanceUSD: '主播上周结算金额USD',
    rangeBalance: '主播当周结算钻石数',
    rangeBalanceUSD: '主播当周结算金额USD'
  },
  {
    settlement: 'تقرير التسوية',
    search: 'بحث',
    selectData: 'اختر التاريخ',
    date: 'تاريخ البيانات',
    country: 'دولة المضيفة',
    export: 'تصدير',
    name: 'اسم المضيفة',
    rid: 'ID',
    lastWeekRangeBalance: 'عدد سحب الألماس الأسبوع الماضي',
    lastWeekRangeBalanceUSD: 'إجمالي مبلغ التسوية للأسبوع الماضي',
    rangeBalance: 'عدد سحب الألماس لهذا الاسبوع',
    rangeBalanceUSD: 'إجمالي مبلغ التسوية هذا الأسبوع'
  },
  {
    settlement: 'Informe de Nómina',
    search: 'Buscar',
    selectData: 'Selecciona fecha',
    date: 'Fecha',
    country: 'País',
    export: 'Descargar',
    name: 'Apodo',
    rid: 'ID',
    lastWeekRangeBalance: 'Diamantes de la semana anterior',
    lastWeekRangeBalanceUSD: 'Ingresos de la semana anterior',
    rangeBalance: 'Diamantes de la semana seleccionada',
    rangeBalanceUSD: 'Ingresos de la semana seleccionada'
  }
]

export const block = [
  {
    block: 'Ban Records',
    rid: 'ID',
    id: 'Ban ID',
    search: 'Search',
    blockedTime: 'Ban Start Time',
    blockedDuration: 'Ban Duration',
    reason: 'Ban Reason',
    selectstartDate: 'Select Start Date',
    selectendDate: 'Select End Date'
  },
  {
    block: '封禁记录',
    rid: '主播ID',
    id: '封禁ID',
    search: '查询',
    blockedTime: '封禁开始时间',
    blockedDuration: '封禁时长',
    reason: '封禁原因',
    selectstartDate: '选择开始日期',
    selectendDate: '选择结束日期'
  },
  {
    block: 'سجلات الحظر',
    rid: 'ID',
    id: 'معرف الحظر',
    search: 'بحث',
    blockedTime: 'وقت بدء الحظر',
    blockedDuration: 'مدة الحظر',
    reason: 'سبب الحظر',
    selectstartDate: 'اختر تاريخ البدء',
    selectendDate: 'اختر تاريخ الانتهاء'
  },
  {
    block: 'Registro de Bloqueos',
    rid: 'ID',
    id: 'ID',
    search: 'Buscar',
    blockedTime: 'Fecha del bloqueo',
    blockedDuration: 'Duración del bloqueo',
    reason: 'Motivo del bloqueo',
    selectstartDate: 'Selecciona fecha de inicio',
    selectendDate: 'Selecciona fecha de finalización'
  }
]
